import { ChangeDetectionStrategy, Component, effect, input, output, signal } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { AgentNetworkUpdateDto, AgentType, KNOWN_REAL_ESTATE_NETWORKS } from '@workspace/data-types';

@Component({
  selector: 'etxe-agent-network-form',
  imports: [MatFormFieldModule, MatSelectModule, MatInputModule, MatIconModule],
  templateUrl: './agent-network-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentNetworkFormComponent {
  readonly agentType = input<AgentType>('titulaire');
  readonly network = input<string>('');

  readonly networkChange = output<string>();
  readonly validityChanged = output<boolean>();
  readonly dtoChanged = output<{ dto: AgentNetworkUpdateDto; changed: boolean }>();

  readonly knownNetworks = KNOWN_REAL_ESTATE_NETWORKS;
  readonly isCustomNetwork = signal<boolean>(false);
  readonly customNetworkName = signal<string>('');
  private currentNetwork = '';

  constructor() {
    effect(() => {
      const net = this.network();
      this.currentNetwork = net;
      if (net && !(this.knownNetworks as readonly string[]).includes(net)) {
        this.isCustomNetwork.set(true);
        this.customNetworkName.set(net);
      }
      this.validityChanged.emit(true);
      this.dtoChanged.emit({ dto: { network: net }, changed: false });
    });
  }

  onNetworkSelected(net: string): void {
    if (net === 'Autre') {
      this.isCustomNetwork.set(true);
      const val = this.customNetworkName();
      this.emitChange(val);
    } else {
      this.isCustomNetwork.set(false);
      this.emitChange(net);
    }
  }

  onCustomNetworkChange(name: string): void {
    this.customNetworkName.set(name);
    this.emitChange(name);
  }

  onAgencyNameChange(name: string): void {
    this.emitChange(name);
  }

  private emitChange(val: string): void {
    this.currentNetwork = val;
    this.networkChange.emit(val);
    this.validityChanged.emit(true);
    this.dtoChanged.emit({ dto: { network: val }, changed: val !== (this.network() || '') });
  }
}
